import React, { useState, useEffect } from 'react';
import Header from '../../shared/header';
import Footer from '../../shared/footer';

const Home = () => {
  const backgroundImages = [
    "https://greendirectorydata.s3.us-east-2.amazonaws.com/ex4.jpg",
    "https://greendirectorydata.s3.us-east-2.amazonaws.com/ex6.jpg",
    "https://greendirectorydata.s3.us-east-2.amazonaws.com/ex7.jpg",
  ];

  const [backgroundImage, setBackgroundImage] = useState(backgroundImages[0]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loaded, setLoaded] = useState(false); 

  const handleImageChange = (selectedValue) => {
    setLoaded(false); 
    preloadImage(backgroundImages[selectedValue - 1], () => {
      setBackgroundImage(backgroundImages[selectedValue - 1]);
      setCurrentIndex(selectedValue - 1);
    });
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setLoaded(false);
      setCurrentIndex((prevIndex) => {
        const nextIndex = (prevIndex + 1) % backgroundImages.length;
        preloadImage(backgroundImages[nextIndex], () => {
          setBackgroundImage(backgroundImages[nextIndex]);
        });
        return nextIndex;
      });
    }, 10000);

    return () => clearInterval(intervalId);
  }, [backgroundImages]);

  const preloadImage = (src, callback) => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      callback(); 
    };
  };

  return (
    <div
      className={`autogrph-main ${loaded ? 'loaded' : ''}`}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className='header-footer-main-div'>
        <Header />
        <Footer
          hideScrollButton={true}
          ContentHideHome={true}
          onRadioChange={handleImageChange}
        />
      </div>
    </div>
  );
};

export default Home;
